import { Entity, Field } from 'typegraph';

import Entry from "./Entry";

@Entity({one: "featured", many: "featureds"})
export default class Featured {

	@Field()
	public id: string;

	@Field({entity: Entry})
	public entry: Entry;

	@Field()
	public imageURL: string;

}


// WEBPACK FOOTER //
// ./src/panels/featuredItems/entities/Featured.ts